import { render, staticRenderFns } from "./LeaseStatusTag.vue?vue&type=template&id=2c227bbc&scoped=true&"
import script from "./LeaseStatusTag.vue?vue&type=script&lang=js&"
export * from "./LeaseStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./LeaseStatusTag.vue?vue&type=style&index=0&id=2c227bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c227bbc",
  null
  
)

export default component.exports